

export const clearFilterData = {
  AptTmSt: null,
  AptTmEn: null,
  ScId: null,
  CusId: null, 
  JobId: null,
  Bkg: null, 
  IsFinDte: '',
  JobNo: null,
  ContNo: null,
  JobOrdId: null,
}

export const initFilterData = {
  ...clearFilterData,
  IsFinDte: 0
}